export class Version {
  private readonly commit: string;
  private readonly timestamp: string;
  constructor() {
    this.commit = import.meta.env.VITE_APP_GIT_COMMIT;
    this.timestamp = import.meta.env.VITE_APP_GIT_TIMESTAMP;
  }
  public commitTimeStamp(): string {
    return `${this.commit}-${this.timestamp}`;
  }
}
